import { render } from "./multipleMatch.vue?vue&type=template&id=0ba4317e&scoped=true"
import script from "./multipleMatch.vue?vue&type=script&lang=js"
export * from "./multipleMatch.vue?vue&type=script&lang=js"

import "./multipleMatch.vue?vue&type=style&index=0&id=0ba4317e&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba4317e"]])

export default __exports__